import { Space } from 'antd';
import { useState } from 'react';

import { ShiftListItemDto } from '@clh/api-client';

import { useSelection } from '../../../hooks/use-selection';
import ObjectPropertyList from '../../../record-details/object-property-list';

import { AuthorizationChecker } from './authorization-checker';
import { CancellationDetails } from './cancellation-details';
import { NurseCancellationsTable } from './nurse-cancellations-table';
import { createNurseProfileFieldRenderer } from './nurse-profile-field';
import { createPayRateFieldRenderer } from './pay-rate-field';
import { createStipendsFieldRenderer } from './stipends-field';
import { createSubmittedTimeFieldRenderer } from './submitted-time-field';

export default function AssignmentTab() {
    const { selection } = useSelection<ShiftListItemDto>();
    const [editAssignedNurse, setEditAssignedNurse] = useState(false);
    const [editPayRate, setEditPayRate] = useState(false);
    const [editMinutesWorked, setEditMinutesWorked] = useState(false);
    const [addingStipend, setAddingStipend] = useState(false);

    return (
        <Space direction="vertical" style={{ width: '100%' }} size="large">
            <ObjectPropertyList
                values={{
                    ...selection,
                    submittedTime: selection.minutesWorked,
                }}
                fields={{
                    nurseProfile: createNurseProfileFieldRenderer(
                        selection.shiftType,
                        editAssignedNurse,
                        () => setEditAssignedNurse(true),
                        () => setEditAssignedNurse(false)
                    ),
                    payRate: createPayRateFieldRenderer(
                        selection,
                        editPayRate,
                        () => setEditPayRate(true),
                        () => setEditPayRate(false)
                    ),
                    stipends: createStipendsFieldRenderer(
                        selection,
                        addingStipend,
                        () => setAddingStipend(true),
                        () => setAddingStipend(false)
                    ),
                    submittedTimeAt: true,
                    submittedTime: createSubmittedTimeFieldRenderer(
                        selection,
                        editMinutesWorked,
                        () => setEditMinutesWorked(true),
                        () => setEditMinutesWorked(false)
                    ),
                }}
            />

            <CancellationDetails selection={selection} />

            <NurseCancellationsTable selection={selection} />

            <AuthorizationChecker />
        </Space>
    );
}
